import { render } from "./PatientRegModal.vue?vue&type=template&id=875f051a&scoped=true"
import script from "./PatientRegModal.vue?vue&type=script&lang=js"
export * from "./PatientRegModal.vue?vue&type=script&lang=js"

import "./PatientRegModal.vue?vue&type=style&index=0&id=875f051a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-875f051a"]])

export default __exports__